// extracted by mini-css-extract-plugin
export default {"withMinimalCard":"ContentfulCards-module__withMinimalCard--j3Dpa"};